export const options = [
  {
    id: "",
    value: "All",
  },
  {
    id: "corporations",
    value: "Corporation",
  },
  {
    id: "small_emerging_business_or_supplier",
    value: "Small & Emerging Business or Supplier",
  },
  {
    id: "financial_organizations",
    value: "Financial Services",
  },
  {
    id: "government_agency_public_entity",
    value: "Government Agency, Public Entity",
  },
  {
    id: "nonprofit",
    value: "Non-Profit",
  },
  {
    id: "dc_education",
    value: "Education",
  },
  {
    id: "professional",
    value: "Professional",
  },
  {
    id: "other",
    value: "Other",
  },
]
